import React, { useState } from "react";
import { Accordion } from "react-bootstrap";
import { ReactComponent as HashTag } from "./Assets/hashTag.svg";

import "./BigCardsAccordion.scss";

const BigCardsAccordion = ({ accordionData }) => {
  const [activeAccordion, setActiveAccordion] = useState(
    accordionData.accordionItems[0].eventKey
  );

  const toggleAccordion = (eventKey) => {
    setActiveAccordion(activeAccordion === eventKey ? null : eventKey);
  };

  return (
    <div className="accordion-container d-flex flex-column justify-content-xl-center align-items-center align-items-lg-start">
      <Accordion
        className="accordion-borderless position-relative w-100"
        defaultActiveKey={"0"}
      >
        {accordionData.accordionItems.map((item, index) => (
          <Accordion.Item
            className={`${
              activeAccordion === item.eventKey ? "active-accordion" : ""
            }`}
            eventKey={item.eventKey}
            key={index}
          >
            <Accordion.Header onClick={() => toggleAccordion(item.eventKey)}>
              <span className="font-pnsb display-xs text-white font-size-24">
                {item.headerText}
              </span>

              {/* {item.quarter ? (
                <span className="accordion-quarter font-poppins-medium font-size-18 text-white">
                  {item.quarter}
                </span>
              ) : null} */}
            </Accordion.Header>

            <Accordion.Body className="d-flex flex-column align-items-center text-start">
              {item.bodyText}
            </Accordion.Body>
          </Accordion.Item>
        ))}

        <div
          className="event-container d-flex align-items-center"
          style={{ background: accordionData.accordionTagGradient }}
        >
          <div className="hash-tag d-flex justify-content-center align-items-center">
            <HashTag />
          </div>

          <span className="event-title font-poppins-medium font-size-18">
            {accordionData.accordionTag}
          </span>
        </div>
      </Accordion>
    </div>
  );
};

export default BigCardsAccordion;
